import { render, staticRenderFns } from "./strengthCustomTab.vue?vue&type=template&id=a88601aa&"
import script from "./strengthCustomTab.vue?vue&type=script&lang=js&"
export * from "./strengthCustomTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports